<template>

    <div class="wrapFumetto">
      <!-- <div class="slds-popover_tooltip slds-nubbin_left-bottom slds-popover__body 
                slds-slide-from-bottom-to-top slds-slide-from-right-to-left box fumetto" role="tooltip" 
                id={action.id}  
                v-if="isVisible">
        <slot></slot>
      </div> -->
      <div class="slds-popover_tooltip slds-nubbin_right-top slds-popover__body 
            slds-slide-from-bottom-to-top slds-slide-from-left-to-right box fumetto"
            role="tooltip" 
            id={action.id}  
            v-if="isVisible">
        <slot></slot>
      </div>


    </div>
    
	
</template>
<script>
 export default{
    props:{
      isVisible: Boolean
    }
 }
</script>

<style>

 .wrapFumetto{
    position: absolute;
    /* min-width: 80px; */
    width: 250px !important;
    /* max-width: 450px; */
    z-index: 9999;
    right: 70px;
    top: 30px;
    /* right:250px */
 }
 .fumetto{
  position:relative; 
  background-color: rgb(243, 242, 242); 
  /* top: -5vh; 
  left: 2vw; */
  top: -35px;
border: 1px solid black;
 }





</style>
